import * as authRoutines from '../Containers/Auth/authRoutines';
const initialState = {
    loading: false,
    loggedIn: false,
    user: null,
};

export default function loginReducer(state = initialState, action = {}) {
    switch (action.type) {
        case authRoutines.commandCenterLogout.TRIGGER:
            return {
                ...state,
                loading: true,
            };
        case authRoutines.firebaseAuthentication.SUCCESS:
            return {
                ...state,
                loading: false,
                loggedIn: true,
                user: action.payload,
            };
        case authRoutines.commandCenterLogin.FAILURE:
            return {
                ...state,
                loading: false,
            };
        case authRoutines.commandCenterLogout.SUCCESS:
            return initialState;
        case authRoutines.commandCenterLogout.FAILURE:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
}
